import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  Companion_getInstance1i8v5a4alj7fe as Companion_getInstance,
  Companion_getInstance1toq7c46z6qs1 as Companion_getInstance_0,
} from '../enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  MonetaryValue__toFullString_impl_igjjwy52pd76w4j0ou as MonetaryValue__toFullString_impl_igjjwy,
  $serializer_getInstance3qhgvjcaya2da as $serializer_getInstance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
} from '../supportModels.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { rangeTo3js8ciqegc9cl as rangeTo } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowSnapshotReport.TableRow', this, 13);
        tmp0_serialDesc.c1b('Project ID', false);
        tmp0_serialDesc.c1b('Contractor', false);
        tmp0_serialDesc.c1b('State', false);
        tmp0_serialDesc.c1b('Status', false);
        tmp0_serialDesc.c1b('Total Deposits', false);
        tmp0_serialDesc.c1b('Total Signed-Off Amount', false);
        tmp0_serialDesc.c1b('Contractor Signed-Off Portion', false);
        tmp0_serialDesc.c1b('CrowPay Fee Earned', false);
        tmp0_serialDesc.c1b('Contractor Collected Amount', false);
        tmp0_serialDesc.c1b('Client Collected Amount', false);
        tmp0_serialDesc.c1b('Total In Escrow', false);
        tmp0_serialDesc.c1b('Project Escrow', false);
        tmp0_serialDesc.c1b('Contractor Payable Escrow', false);
        this.a9n_1 = tmp0_serialDesc;
      }
      b9n(encoder, value) {
        var tmp0_desc = this.a9n_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.c9n_1);
        tmp1_output.a15(tmp0_desc, 1, value.d9n_1);
        tmp1_output.a15(tmp0_desc, 2, value.e9n_1);
        tmp1_output.a15(tmp0_desc, 3, value.f9n_1);
        tmp1_output.a15(tmp0_desc, 4, value.g9n_1);
        tmp1_output.a15(tmp0_desc, 5, value.h9n_1);
        tmp1_output.a15(tmp0_desc, 6, value.i9n_1);
        tmp1_output.a15(tmp0_desc, 7, value.j9n_1);
        tmp1_output.a15(tmp0_desc, 8, value.k9n_1);
        tmp1_output.a15(tmp0_desc, 9, value.l9n_1);
        tmp1_output.a15(tmp0_desc, 10, value.m9n_1);
        tmp1_output.a15(tmp0_desc, 11, value.n9n_1);
        tmp1_output.a15(tmp0_desc, 12, value.o9n_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b9n(encoder, value instanceof TableRow() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a9n_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.l13(tmp0_desc);
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp17_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp17_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.v13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp17_input.v13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.v13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.v13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.v13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp17_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp17_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.v13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp17_input.v13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.v13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.v13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.v13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return TableRow().p9n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.a9n_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ProjectEscrowSnapshotReport$Request$Companion$$childSerializers$_anonymous__tue8fd() {
  return new (LinkedHashSetSerializer())(DeferToContextualUuidSerializer_getInstance());
}
function ProjectEscrowSnapshotReport$Request$Companion$$childSerializers$_anonymous__tue8fd_0() {
  return new (LinkedHashSetSerializer())(DeferToContextualUuidSerializer_getInstance());
}
function ProjectEscrowSnapshotReport$Request$Companion$$childSerializers$_anonymous__tue8fd_1() {
  return new (LinkedHashSetSerializer())(Companion_getInstance().m2a());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectEscrowSnapshotReport$Request$Companion$$childSerializers$_anonymous__tue8fd);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectEscrowSnapshotReport$Request$Companion$$childSerializers$_anonymous__tue8fd_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b8s_1 = [null, tmp_1, tmp_3, lazy(tmp_4, ProjectEscrowSnapshotReport$Request$Companion$$childSerializers$_anonymous__tue8fd_1)];
      }
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowSnapshotReport.Request', this, 4);
        tmp0_serialDesc.c1b('at', false);
        tmp0_serialDesc.c1b('contractorIds', false);
        tmp0_serialDesc.c1b('projectIds', false);
        tmp0_serialDesc.c1b('states', false);
        this.q9n_1 = tmp0_serialDesc;
      }
      r9n(encoder, value) {
        var tmp0_desc = this.q9n_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().b8s_1;
        tmp1_output.c15(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), value.s9n_1);
        tmp1_output.d15(tmp0_desc, 1, tmp2_cached[1].f2(), value.t9n_1);
        tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.u9n_1);
        tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.v9n_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r9n(encoder, value instanceof Request() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q9n_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_2().b8s_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return Request().w9n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.q9n_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_2().b8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [InstantIso8601Serializer_getInstance(), get_nullable(tmp0_cached[1].f2()), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function ProjectEscrowSnapshotReport$Companion$$childSerializers$_anonymous__yuqx9w() {
  return Companion_getInstance().m2a();
}
function ProjectEscrowSnapshotReport$Companion$$childSerializers$_anonymous__yuqx9w_0() {
  return Companion_getInstance_0().m2a();
}
var TableRowClass;
function TableRow() {
  if (TableRowClass === VOID) {
    class $ {
      static x9n(Project_ID_dy942, Contractor, State, Status, Total_Deposits_ieuyb5, Total_Signed_Off_Amount_v9htuq, Contractor_Signed_Off_Portion_x4abf4, CrowPay_Fee_Earned_y8z2ao, Contractor_Collected_Amount_f8xapy, Client_Collected_Amount_rxbcws, Total_In_Escrow_g58msc, Project_Escrow_nm6sno, Contractor_Payable_Escrow_z9tbny) {
        var $this = createThis(this);
        $this.c9n_1 = Project_ID_dy942;
        $this.d9n_1 = Contractor;
        $this.e9n_1 = State;
        $this.f9n_1 = Status;
        $this.g9n_1 = Total_Deposits_ieuyb5;
        $this.h9n_1 = Total_Signed_Off_Amount_v9htuq;
        $this.i9n_1 = Contractor_Signed_Off_Portion_x4abf4;
        $this.j9n_1 = CrowPay_Fee_Earned_y8z2ao;
        $this.k9n_1 = Contractor_Collected_Amount_f8xapy;
        $this.l9n_1 = Client_Collected_Amount_rxbcws;
        $this.m9n_1 = Total_In_Escrow_g58msc;
        $this.n9n_1 = Project_Escrow_nm6sno;
        $this.o9n_1 = Contractor_Payable_Escrow_z9tbny;
        return $this;
      }
      static y9n(snapshot) {
        return this.x9n(snapshot.z9n_1, snapshot.a9o_1, snapshot.b9o_1.e9b_1, snapshot.c9o_1.s9b_1, MonetaryValue__toFullString_impl_igjjwy(snapshot.d9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.e9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.f9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.g9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.h9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.i9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.j9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.k9o_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.l9o_1));
      }
      toString() {
        return 'TableRow(Project ID=' + this.c9n_1.toString() + ', Contractor=' + this.d9n_1 + ', State=' + this.e9n_1 + ', Status=' + this.f9n_1 + ', Total Deposits=' + this.g9n_1 + ', Total Signed-Off Amount=' + this.h9n_1 + ', Contractor Signed-Off Portion=' + this.i9n_1 + ', CrowPay Fee Earned=' + this.j9n_1 + ', Contractor Collected Amount=' + this.k9n_1 + ', Client Collected Amount=' + this.l9n_1 + ', Total In Escrow=' + this.m9n_1 + ', Project Escrow=' + this.n9n_1 + ', Contractor Payable Escrow=' + this.o9n_1 + ')';
      }
      hashCode() {
        var result = this.c9n_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.d9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n9n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o9n_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableRow()))
          return false;
        if (!this.c9n_1.equals(other.c9n_1))
          return false;
        if (!(this.d9n_1 === other.d9n_1))
          return false;
        if (!(this.e9n_1 === other.e9n_1))
          return false;
        if (!(this.f9n_1 === other.f9n_1))
          return false;
        if (!(this.g9n_1 === other.g9n_1))
          return false;
        if (!(this.h9n_1 === other.h9n_1))
          return false;
        if (!(this.i9n_1 === other.i9n_1))
          return false;
        if (!(this.j9n_1 === other.j9n_1))
          return false;
        if (!(this.k9n_1 === other.k9n_1))
          return false;
        if (!(this.l9n_1 === other.l9n_1))
          return false;
        if (!(this.m9n_1 === other.m9n_1))
          return false;
        if (!(this.n9n_1 === other.n9n_1))
          return false;
        if (!(this.o9n_1 === other.o9n_1))
          return false;
        return true;
      }
      static p9n(seen0, Project_ID_dy942, Contractor, State, Status, Total_Deposits_ieuyb5, Total_Signed_Off_Amount_v9htuq, Contractor_Signed_Off_Portion_x4abf4, CrowPay_Fee_Earned_y8z2ao, Contractor_Collected_Amount_f8xapy, Client_Collected_Amount_rxbcws, Total_In_Escrow_g58msc, Project_Escrow_nm6sno, Contractor_Payable_Escrow_z9tbny, serializationConstructorMarker) {
        if (!(8191 === (8191 & seen0))) {
          throwMissingFieldException(seen0, 8191, $serializer_getInstance_0().a9n_1);
        }
        var $this = createThis(this);
        $this.c9n_1 = Project_ID_dy942;
        $this.d9n_1 = Contractor;
        $this.e9n_1 = State;
        $this.f9n_1 = Status;
        $this.g9n_1 = Total_Deposits_ieuyb5;
        $this.h9n_1 = Total_Signed_Off_Amount_v9htuq;
        $this.i9n_1 = Contractor_Signed_Off_Portion_x4abf4;
        $this.j9n_1 = CrowPay_Fee_Earned_y8z2ao;
        $this.k9n_1 = Contractor_Collected_Amount_f8xapy;
        $this.l9n_1 = Client_Collected_Amount_rxbcws;
        $this.m9n_1 = Total_In_Escrow_g58msc;
        $this.n9n_1 = Project_Escrow_nm6sno;
        $this.o9n_1 = Contractor_Payable_Escrow_z9tbny;
        return $this;
      }
    }
    initMetadataForClass($, 'TableRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    TableRowClass = $;
  }
  return TableRowClass;
}
var RequestClass;
function Request() {
  if (RequestClass === VOID) {
    class $ {
      constructor(at, contractorIds, projectIds, states) {
        Companion_getInstance_2();
        this.s9n_1 = at;
        this.t9n_1 = contractorIds;
        this.u9n_1 = projectIds;
        this.v9n_1 = states;
      }
      toString() {
        return 'Request(at=' + this.s9n_1.toString() + ', contractorIds=' + toString_0(this.t9n_1) + ', projectIds=' + toString_0(this.u9n_1) + ', states=' + toString_0(this.v9n_1) + ')';
      }
      hashCode() {
        var result = this.s9n_1.hashCode();
        result = imul(result, 31) + (this.t9n_1 == null ? 0 : hashCode(this.t9n_1)) | 0;
        result = imul(result, 31) + (this.u9n_1 == null ? 0 : hashCode(this.u9n_1)) | 0;
        result = imul(result, 31) + (this.v9n_1 == null ? 0 : hashCode(this.v9n_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Request()))
          return false;
        if (!this.s9n_1.equals(other.s9n_1))
          return false;
        if (!equals(this.t9n_1, other.t9n_1))
          return false;
        if (!equals(this.u9n_1, other.u9n_1))
          return false;
        if (!equals(this.v9n_1, other.v9n_1))
          return false;
        return true;
      }
      static w9n(seen0, at, contractorIds, projectIds, states, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_1().q9n_1);
        }
        var $this = createThis(this);
        $this.s9n_1 = at;
        $this.t9n_1 = contractorIds;
        $this.u9n_1 = projectIds;
        $this.v9n_1 = states;
        return $this;
      }
    }
    initMetadataForClass($, 'Request', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    RequestClass = $;
  }
  return RequestClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectEscrowSnapshotReport$Companion$$childSerializers$_anonymous__yuqx9w);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a8s_1 = [null, null, tmp_1, lazy(tmp_2, ProjectEscrowSnapshotReport$Companion$$childSerializers$_anonymous__yuqx9w_0), null, null, null, null, null, null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowSnapshotReport', this, 13);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.c1b('contractorName', false);
        tmp0_serialDesc.c1b('state', false);
        tmp0_serialDesc.c1b('projectState', false);
        tmp0_serialDesc.c1b('totalDeposits', false);
        tmp0_serialDesc.c1b('totalSignedOff', false);
        tmp0_serialDesc.c1b('contractorSignedOffPortion', false);
        tmp0_serialDesc.c1b('crowpayFeeEarned', false);
        tmp0_serialDesc.c1b('contractorCollected', false);
        tmp0_serialDesc.c1b('clientCollected', false);
        tmp0_serialDesc.c1b('totalInEscrow', false);
        tmp0_serialDesc.c1b('projectEscrow', false);
        tmp0_serialDesc.c1b('contractorPayableEscrow', false);
        this.m9o_1 = tmp0_serialDesc;
      }
      n9o(encoder, value) {
        var tmp0_desc = this.m9o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().a8s_1;
        tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.z9n_1);
        tmp1_output.a15(tmp0_desc, 1, value.a9o_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.b9o_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.c9o_1);
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance(), new (MonetaryValue())(value.d9o_1));
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance(), new (MonetaryValue())(value.e9o_1));
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance(), new (MonetaryValue())(value.f9o_1));
        tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance(), new (MonetaryValue())(value.g9o_1));
        tmp1_output.c15(tmp0_desc, 8, $serializer_getInstance(), new (MonetaryValue())(value.h9o_1));
        tmp1_output.c15(tmp0_desc, 9, $serializer_getInstance(), new (MonetaryValue())(value.i9o_1));
        tmp1_output.c15(tmp0_desc, 10, $serializer_getInstance(), new (MonetaryValue())(value.j9o_1));
        tmp1_output.c15(tmp0_desc, 11, $serializer_getInstance(), new (MonetaryValue())(value.k9o_1));
        tmp1_output.c15(tmp0_desc, 12, $serializer_getInstance(), new (MonetaryValue())(value.l9o_1));
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n9o(encoder, value instanceof ProjectEscrowSnapshotReport() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m9o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.l13(tmp0_desc);
        var tmp18_cached = Companion_getInstance_3().a8s_1;
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.x13(tmp0_desc, 2, tmp18_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.x13(tmp0_desc, 3, tmp18_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp8_local4;
          var tmp_1 = tmp17_input.x13(tmp0_desc, 4, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp8_local4 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp9_local5;
          var tmp_4 = tmp17_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp9_local5 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp10_local6;
          var tmp_7 = tmp17_input.x13(tmp0_desc, 6, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp10_local6 = tmp_7 == null ? null : tmp_7.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_8 = $serializer_getInstance();
          var tmp_9 = tmp11_local7;
          var tmp_10 = tmp17_input.x13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
          tmp11_local7 = tmp_10 == null ? null : tmp_10.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          var tmp_11 = $serializer_getInstance();
          var tmp_12 = tmp12_local8;
          var tmp_13 = tmp17_input.x13(tmp0_desc, 8, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
          tmp12_local8 = tmp_13 == null ? null : tmp_13.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          var tmp_14 = $serializer_getInstance();
          var tmp_15 = tmp13_local9;
          var tmp_16 = tmp17_input.x13(tmp0_desc, 9, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
          tmp13_local9 = tmp_16 == null ? null : tmp_16.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          var tmp_17 = $serializer_getInstance();
          var tmp_18 = tmp14_local10;
          var tmp_19 = tmp17_input.x13(tmp0_desc, 10, tmp_17, tmp_18 == null ? null : new (MonetaryValue())(tmp_18));
          tmp14_local10 = tmp_19 == null ? null : tmp_19.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          var tmp_20 = $serializer_getInstance();
          var tmp_21 = tmp15_local11;
          var tmp_22 = tmp17_input.x13(tmp0_desc, 11, tmp_20, tmp_21 == null ? null : new (MonetaryValue())(tmp_21));
          tmp15_local11 = tmp_22 == null ? null : tmp_22.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          var tmp_23 = $serializer_getInstance();
          var tmp_24 = tmp16_local12;
          var tmp_25 = tmp17_input.x13(tmp0_desc, 12, tmp_23, tmp_24 == null ? null : new (MonetaryValue())(tmp_24));
          tmp16_local12 = tmp_25 == null ? null : tmp_25.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.x13(tmp0_desc, 2, tmp18_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.x13(tmp0_desc, 3, tmp18_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_26 = $serializer_getInstance();
                var tmp_27 = tmp8_local4;
                var tmp_28 = tmp17_input.x13(tmp0_desc, 4, tmp_26, tmp_27 == null ? null : new (MonetaryValue())(tmp_27));
                tmp8_local4 = tmp_28 == null ? null : tmp_28.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_29 = $serializer_getInstance();
                var tmp_30 = tmp9_local5;
                var tmp_31 = tmp17_input.x13(tmp0_desc, 5, tmp_29, tmp_30 == null ? null : new (MonetaryValue())(tmp_30));
                tmp9_local5 = tmp_31 == null ? null : tmp_31.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_32 = $serializer_getInstance();
                var tmp_33 = tmp10_local6;
                var tmp_34 = tmp17_input.x13(tmp0_desc, 6, tmp_32, tmp_33 == null ? null : new (MonetaryValue())(tmp_33));
                tmp10_local6 = tmp_34 == null ? null : tmp_34.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_35 = $serializer_getInstance();
                var tmp_36 = tmp11_local7;
                var tmp_37 = tmp17_input.x13(tmp0_desc, 7, tmp_35, tmp_36 == null ? null : new (MonetaryValue())(tmp_36));
                tmp11_local7 = tmp_37 == null ? null : tmp_37.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                var tmp_38 = $serializer_getInstance();
                var tmp_39 = tmp12_local8;
                var tmp_40 = tmp17_input.x13(tmp0_desc, 8, tmp_38, tmp_39 == null ? null : new (MonetaryValue())(tmp_39));
                tmp12_local8 = tmp_40 == null ? null : tmp_40.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                var tmp_41 = $serializer_getInstance();
                var tmp_42 = tmp13_local9;
                var tmp_43 = tmp17_input.x13(tmp0_desc, 9, tmp_41, tmp_42 == null ? null : new (MonetaryValue())(tmp_42));
                tmp13_local9 = tmp_43 == null ? null : tmp_43.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                var tmp_44 = $serializer_getInstance();
                var tmp_45 = tmp14_local10;
                var tmp_46 = tmp17_input.x13(tmp0_desc, 10, tmp_44, tmp_45 == null ? null : new (MonetaryValue())(tmp_45));
                tmp14_local10 = tmp_46 == null ? null : tmp_46.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                var tmp_47 = $serializer_getInstance();
                var tmp_48 = tmp15_local11;
                var tmp_49 = tmp17_input.x13(tmp0_desc, 11, tmp_47, tmp_48 == null ? null : new (MonetaryValue())(tmp_48));
                tmp15_local11 = tmp_49 == null ? null : tmp_49.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                var tmp_50 = $serializer_getInstance();
                var tmp_51 = tmp16_local12;
                var tmp_52 = tmp17_input.x13(tmp0_desc, 12, tmp_50, tmp_51 == null ? null : new (MonetaryValue())(tmp_51));
                tmp16_local12 = tmp_52 == null ? null : tmp_52.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return ProjectEscrowSnapshotReport().o9o(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.m9o_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_3().a8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_2() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var ProjectEscrowSnapshotReportClass;
function ProjectEscrowSnapshotReport() {
  if (ProjectEscrowSnapshotReportClass === VOID) {
    class $ {
      p9o() {
        return TableRow().y9n(this);
      }
      toString() {
        return 'ProjectEscrowSnapshotReport(project=' + this.z9n_1.toString() + ', contractorName=' + this.a9o_1 + ', state=' + this.b9o_1.toString() + ', projectState=' + toString(this.c9o_1) + ', totalDeposits=' + MonetaryValue__toString_impl_xslc77(this.d9o_1) + ', totalSignedOff=' + MonetaryValue__toString_impl_xslc77(this.e9o_1) + ', contractorSignedOffPortion=' + MonetaryValue__toString_impl_xslc77(this.f9o_1) + ', crowpayFeeEarned=' + MonetaryValue__toString_impl_xslc77(this.g9o_1) + ', contractorCollected=' + MonetaryValue__toString_impl_xslc77(this.h9o_1) + ', clientCollected=' + MonetaryValue__toString_impl_xslc77(this.i9o_1) + ', totalInEscrow=' + MonetaryValue__toString_impl_xslc77(this.j9o_1) + ', projectEscrow=' + MonetaryValue__toString_impl_xslc77(this.k9o_1) + ', contractorPayableEscrow=' + MonetaryValue__toString_impl_xslc77(this.l9o_1) + ')';
      }
      hashCode() {
        var result = this.z9n_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.a9o_1) | 0;
        result = imul(result, 31) + this.b9o_1.hashCode() | 0;
        result = imul(result, 31) + this.c9o_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.d9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.e9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.f9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.g9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.h9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.i9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.j9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.k9o_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.l9o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectEscrowSnapshotReport()))
          return false;
        if (!this.z9n_1.equals(other.z9n_1))
          return false;
        if (!(this.a9o_1 === other.a9o_1))
          return false;
        if (!this.b9o_1.equals(other.b9o_1))
          return false;
        if (!this.c9o_1.equals(other.c9o_1))
          return false;
        if (!(this.d9o_1 === other.d9o_1))
          return false;
        if (!(this.e9o_1 === other.e9o_1))
          return false;
        if (!(this.f9o_1 === other.f9o_1))
          return false;
        if (!(this.g9o_1 === other.g9o_1))
          return false;
        if (!(this.h9o_1 === other.h9o_1))
          return false;
        if (!(this.i9o_1 === other.i9o_1))
          return false;
        if (!(this.j9o_1 === other.j9o_1))
          return false;
        if (!(this.k9o_1 === other.k9o_1))
          return false;
        if (!(this.l9o_1 === other.l9o_1))
          return false;
        return true;
      }
      static o9o(seen0, project, contractorName, state, projectState, totalDeposits, totalSignedOff, contractorSignedOffPortion, crowpayFeeEarned, contractorCollected, clientCollected, totalInEscrow, projectEscrow, contractorPayableEscrow, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(8191 === (8191 & seen0))) {
          throwMissingFieldException(seen0, 8191, $serializer_getInstance_2().m9o_1);
        }
        var $this = createThis(this);
        $this.z9n_1 = project;
        $this.a9o_1 = contractorName;
        $this.b9o_1 = state;
        $this.c9o_1 = projectState;
        $this.d9o_1 = totalDeposits;
        $this.e9o_1 = totalSignedOff;
        $this.f9o_1 = contractorSignedOffPortion;
        $this.g9o_1 = crowpayFeeEarned;
        $this.h9o_1 = contractorCollected;
        $this.i9o_1 = clientCollected;
        $this.j9o_1 = totalInEscrow;
        $this.k9o_1 = projectEscrow;
        $this.l9o_1 = contractorPayableEscrow;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectEscrowSnapshotReport', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    ProjectEscrowSnapshotReportClass = $;
  }
  return ProjectEscrowSnapshotReportClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowHomeownerSnapshotReport.TableRow', this, 13);
        tmp0_serialDesc.c1b('Project ID', false);
        tmp0_serialDesc.c1b('Homeowner', false);
        tmp0_serialDesc.c1b('State', false);
        tmp0_serialDesc.c1b('Status', false);
        tmp0_serialDesc.c1b('Total Deposits', false);
        tmp0_serialDesc.c1b('Total Signed-Off Amount', false);
        tmp0_serialDesc.c1b('Contractor Signed-Off Portion', false);
        tmp0_serialDesc.c1b('CrowPay Fee Earned', false);
        tmp0_serialDesc.c1b('Contractor Collected Amount', false);
        tmp0_serialDesc.c1b('Client Collected Amount', false);
        tmp0_serialDesc.c1b('Total In Escrow', false);
        tmp0_serialDesc.c1b('Project Escrow', false);
        tmp0_serialDesc.c1b('Contractor Payable Escrow', false);
        this.q9o_1 = tmp0_serialDesc;
      }
      r9o(encoder, value) {
        var tmp0_desc = this.q9o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.s9o_1);
        tmp1_output.a15(tmp0_desc, 1, value.t9o_1);
        tmp1_output.a15(tmp0_desc, 2, value.u9o_1);
        tmp1_output.a15(tmp0_desc, 3, value.v9o_1);
        tmp1_output.a15(tmp0_desc, 4, value.w9o_1);
        tmp1_output.a15(tmp0_desc, 5, value.x9o_1);
        tmp1_output.a15(tmp0_desc, 6, value.y9o_1);
        tmp1_output.a15(tmp0_desc, 7, value.z9o_1);
        tmp1_output.a15(tmp0_desc, 8, value.a9p_1);
        tmp1_output.a15(tmp0_desc, 9, value.b9p_1);
        tmp1_output.a15(tmp0_desc, 10, value.c9p_1);
        tmp1_output.a15(tmp0_desc, 11, value.d9p_1);
        tmp1_output.a15(tmp0_desc, 12, value.e9p_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r9o(encoder, value instanceof TableRow_0() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q9o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.l13(tmp0_desc);
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp17_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp17_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.v13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp17_input.v13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.v13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.v13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.v13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp17_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp17_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.v13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp17_input.v13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.v13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.v13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.v13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return TableRow_0().f9p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.q9o_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_3() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function ProjectEscrowHomeownerSnapshotReport$Request$Companion$$childSerializers$_anonymous__jzf9g1() {
  return new (LinkedHashSetSerializer())(DeferToContextualUuidSerializer_getInstance());
}
function ProjectEscrowHomeownerSnapshotReport$Request$Companion$$childSerializers$_anonymous__jzf9g1_0() {
  return new (LinkedHashSetSerializer())(DeferToContextualUuidSerializer_getInstance());
}
function ProjectEscrowHomeownerSnapshotReport$Request$Companion$$childSerializers$_anonymous__jzf9g1_1() {
  return new (LinkedHashSetSerializer())(Companion_getInstance().m2a());
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectEscrowHomeownerSnapshotReport$Request$Companion$$childSerializers$_anonymous__jzf9g1);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectEscrowHomeownerSnapshotReport$Request$Companion$$childSerializers$_anonymous__jzf9g1_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d8s_1 = [null, tmp_1, tmp_3, lazy(tmp_4, ProjectEscrowHomeownerSnapshotReport$Request$Companion$$childSerializers$_anonymous__jzf9g1_1)];
      }
      m2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_5() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowHomeownerSnapshotReport.Request', this, 4);
        tmp0_serialDesc.c1b('at', false);
        tmp0_serialDesc.c1b('homeownerIds', false);
        tmp0_serialDesc.c1b('projectIds', false);
        tmp0_serialDesc.c1b('states', false);
        this.g9p_1 = tmp0_serialDesc;
      }
      h9p(encoder, value) {
        var tmp0_desc = this.g9p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().d8s_1;
        tmp1_output.c15(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), value.i9p_1);
        tmp1_output.d15(tmp0_desc, 1, tmp2_cached[1].f2(), value.j9p_1);
        tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.k9p_1);
        tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.l9p_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.h9p(encoder, value instanceof Request_0() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.g9p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_5().d8s_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.z13(tmp0_desc, 1, tmp9_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.z13(tmp0_desc, 2, tmp9_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.z13(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return Request_0().m9p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.g9p_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_5().d8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [InstantIso8601Serializer_getInstance(), get_nullable(tmp0_cached[1].f2()), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_4() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
function ProjectEscrowHomeownerSnapshotReport$Companion$$childSerializers$_anonymous__vq6gf8() {
  return Companion_getInstance().m2a();
}
function ProjectEscrowHomeownerSnapshotReport$Companion$$childSerializers$_anonymous__vq6gf8_0() {
  return Companion_getInstance_0().m2a();
}
var TableRowClass_0;
function TableRow_0() {
  if (TableRowClass_0 === VOID) {
    class $ {
      static n9p(Project_ID_dy942, Homeowner, State, Status, Total_Deposits_ieuyb5, Total_Signed_Off_Amount_v9htuq, Contractor_Signed_Off_Portion_x4abf4, CrowPay_Fee_Earned_y8z2ao, Contractor_Collected_Amount_f8xapy, Client_Collected_Amount_rxbcws, Total_In_Escrow_g58msc, Project_Escrow_nm6sno, Contractor_Payable_Escrow_z9tbny) {
        var $this = createThis(this);
        $this.s9o_1 = Project_ID_dy942;
        $this.t9o_1 = Homeowner;
        $this.u9o_1 = State;
        $this.v9o_1 = Status;
        $this.w9o_1 = Total_Deposits_ieuyb5;
        $this.x9o_1 = Total_Signed_Off_Amount_v9htuq;
        $this.y9o_1 = Contractor_Signed_Off_Portion_x4abf4;
        $this.z9o_1 = CrowPay_Fee_Earned_y8z2ao;
        $this.a9p_1 = Contractor_Collected_Amount_f8xapy;
        $this.b9p_1 = Client_Collected_Amount_rxbcws;
        $this.c9p_1 = Total_In_Escrow_g58msc;
        $this.d9p_1 = Project_Escrow_nm6sno;
        $this.e9p_1 = Contractor_Payable_Escrow_z9tbny;
        return $this;
      }
      static o9p(snapshot) {
        return this.n9p(snapshot.p9p_1, snapshot.q9p_1, snapshot.r9p_1.e9b_1, snapshot.s9p_1.s9b_1, MonetaryValue__toFullString_impl_igjjwy(snapshot.t9p_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.u9p_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.v9p_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.w9p_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.x9p_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.y9p_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.z9p_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.a9q_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.b9q_1));
      }
      toString() {
        return 'TableRow(Project ID=' + this.s9o_1.toString() + ', Homeowner=' + this.t9o_1 + ', State=' + this.u9o_1 + ', Status=' + this.v9o_1 + ', Total Deposits=' + this.w9o_1 + ', Total Signed-Off Amount=' + this.x9o_1 + ', Contractor Signed-Off Portion=' + this.y9o_1 + ', CrowPay Fee Earned=' + this.z9o_1 + ', Contractor Collected Amount=' + this.a9p_1 + ', Client Collected Amount=' + this.b9p_1 + ', Total In Escrow=' + this.c9p_1 + ', Project Escrow=' + this.d9p_1 + ', Contractor Payable Escrow=' + this.e9p_1 + ')';
      }
      hashCode() {
        var result = this.s9o_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.t9o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u9o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v9o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w9o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x9o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y9o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z9o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a9p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b9p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c9p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.d9p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e9p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableRow_0()))
          return false;
        if (!this.s9o_1.equals(other.s9o_1))
          return false;
        if (!(this.t9o_1 === other.t9o_1))
          return false;
        if (!(this.u9o_1 === other.u9o_1))
          return false;
        if (!(this.v9o_1 === other.v9o_1))
          return false;
        if (!(this.w9o_1 === other.w9o_1))
          return false;
        if (!(this.x9o_1 === other.x9o_1))
          return false;
        if (!(this.y9o_1 === other.y9o_1))
          return false;
        if (!(this.z9o_1 === other.z9o_1))
          return false;
        if (!(this.a9p_1 === other.a9p_1))
          return false;
        if (!(this.b9p_1 === other.b9p_1))
          return false;
        if (!(this.c9p_1 === other.c9p_1))
          return false;
        if (!(this.d9p_1 === other.d9p_1))
          return false;
        if (!(this.e9p_1 === other.e9p_1))
          return false;
        return true;
      }
      static f9p(seen0, Project_ID_dy942, Homeowner, State, Status, Total_Deposits_ieuyb5, Total_Signed_Off_Amount_v9htuq, Contractor_Signed_Off_Portion_x4abf4, CrowPay_Fee_Earned_y8z2ao, Contractor_Collected_Amount_f8xapy, Client_Collected_Amount_rxbcws, Total_In_Escrow_g58msc, Project_Escrow_nm6sno, Contractor_Payable_Escrow_z9tbny, serializationConstructorMarker) {
        if (!(8191 === (8191 & seen0))) {
          throwMissingFieldException(seen0, 8191, $serializer_getInstance_3().q9o_1);
        }
        var $this = createThis(this);
        $this.s9o_1 = Project_ID_dy942;
        $this.t9o_1 = Homeowner;
        $this.u9o_1 = State;
        $this.v9o_1 = Status;
        $this.w9o_1 = Total_Deposits_ieuyb5;
        $this.x9o_1 = Total_Signed_Off_Amount_v9htuq;
        $this.y9o_1 = Contractor_Signed_Off_Portion_x4abf4;
        $this.z9o_1 = CrowPay_Fee_Earned_y8z2ao;
        $this.a9p_1 = Contractor_Collected_Amount_f8xapy;
        $this.b9p_1 = Client_Collected_Amount_rxbcws;
        $this.c9p_1 = Total_In_Escrow_g58msc;
        $this.d9p_1 = Project_Escrow_nm6sno;
        $this.e9p_1 = Contractor_Payable_Escrow_z9tbny;
        return $this;
      }
    }
    initMetadataForClass($, 'TableRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    TableRowClass_0 = $;
  }
  return TableRowClass_0;
}
var RequestClass_0;
function Request_0() {
  if (RequestClass_0 === VOID) {
    class $ {
      constructor(at, homeownerIds, projectIds, states) {
        Companion_getInstance_5();
        this.i9p_1 = at;
        this.j9p_1 = homeownerIds;
        this.k9p_1 = projectIds;
        this.l9p_1 = states;
      }
      toString() {
        return 'Request(at=' + this.i9p_1.toString() + ', homeownerIds=' + toString_0(this.j9p_1) + ', projectIds=' + toString_0(this.k9p_1) + ', states=' + toString_0(this.l9p_1) + ')';
      }
      hashCode() {
        var result = this.i9p_1.hashCode();
        result = imul(result, 31) + (this.j9p_1 == null ? 0 : hashCode(this.j9p_1)) | 0;
        result = imul(result, 31) + (this.k9p_1 == null ? 0 : hashCode(this.k9p_1)) | 0;
        result = imul(result, 31) + (this.l9p_1 == null ? 0 : hashCode(this.l9p_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Request_0()))
          return false;
        if (!this.i9p_1.equals(other.i9p_1))
          return false;
        if (!equals(this.j9p_1, other.j9p_1))
          return false;
        if (!equals(this.k9p_1, other.k9p_1))
          return false;
        if (!equals(this.l9p_1, other.l9p_1))
          return false;
        return true;
      }
      static m9p(seen0, at, homeownerIds, projectIds, states, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_4().g9p_1);
        }
        var $this = createThis(this);
        $this.i9p_1 = at;
        $this.j9p_1 = homeownerIds;
        $this.k9p_1 = projectIds;
        $this.l9p_1 = states;
        return $this;
      }
    }
    initMetadataForClass($, 'Request', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    RequestClass_0 = $;
  }
  return RequestClass_0;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectEscrowHomeownerSnapshotReport$Companion$$childSerializers$_anonymous__vq6gf8);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.c8s_1 = [null, null, tmp_1, lazy(tmp_2, ProjectEscrowHomeownerSnapshotReport$Companion$$childSerializers$_anonymous__vq6gf8_0), null, null, null, null, null, null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_6() {
  if (Companion_instance_4 === VOID)
    new (Companion_4())();
  return Companion_instance_4;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowHomeownerSnapshotReport', this, 13);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.c1b('beneficiaryName', false);
        tmp0_serialDesc.c1b('state', false);
        tmp0_serialDesc.c1b('projectState', false);
        tmp0_serialDesc.c1b('totalDeposits', false);
        tmp0_serialDesc.c1b('totalSignedOff', false);
        tmp0_serialDesc.c1b('contractorSignedOffPortion', false);
        tmp0_serialDesc.c1b('crowpayFeeEarned', false);
        tmp0_serialDesc.c1b('contractorCollected', false);
        tmp0_serialDesc.c1b('clientCollected', false);
        tmp0_serialDesc.c1b('totalInEscrow', false);
        tmp0_serialDesc.c1b('projectEscrow', false);
        tmp0_serialDesc.c1b('contractorPayableEscrow', false);
        this.c9q_1 = tmp0_serialDesc;
      }
      d9q(encoder, value) {
        var tmp0_desc = this.c9q_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_6().c8s_1;
        tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.p9p_1);
        tmp1_output.a15(tmp0_desc, 1, value.q9p_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.r9p_1);
        tmp1_output.c15(tmp0_desc, 3, tmp2_cached[3].f2(), value.s9p_1);
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance(), new (MonetaryValue())(value.t9p_1));
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance(), new (MonetaryValue())(value.u9p_1));
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance(), new (MonetaryValue())(value.v9p_1));
        tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance(), new (MonetaryValue())(value.w9p_1));
        tmp1_output.c15(tmp0_desc, 8, $serializer_getInstance(), new (MonetaryValue())(value.x9p_1));
        tmp1_output.c15(tmp0_desc, 9, $serializer_getInstance(), new (MonetaryValue())(value.y9p_1));
        tmp1_output.c15(tmp0_desc, 10, $serializer_getInstance(), new (MonetaryValue())(value.z9p_1));
        tmp1_output.c15(tmp0_desc, 11, $serializer_getInstance(), new (MonetaryValue())(value.a9q_1));
        tmp1_output.c15(tmp0_desc, 12, $serializer_getInstance(), new (MonetaryValue())(value.b9q_1));
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.d9q(encoder, value instanceof ProjectEscrowHomeownerSnapshotReport() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.c9q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.l13(tmp0_desc);
        var tmp18_cached = Companion_getInstance_6().c8s_1;
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.x13(tmp0_desc, 2, tmp18_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.x13(tmp0_desc, 3, tmp18_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp8_local4;
          var tmp_1 = tmp17_input.x13(tmp0_desc, 4, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp8_local4 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp9_local5;
          var tmp_4 = tmp17_input.x13(tmp0_desc, 5, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp9_local5 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp10_local6;
          var tmp_7 = tmp17_input.x13(tmp0_desc, 6, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp10_local6 = tmp_7 == null ? null : tmp_7.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_8 = $serializer_getInstance();
          var tmp_9 = tmp11_local7;
          var tmp_10 = tmp17_input.x13(tmp0_desc, 7, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
          tmp11_local7 = tmp_10 == null ? null : tmp_10.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          var tmp_11 = $serializer_getInstance();
          var tmp_12 = tmp12_local8;
          var tmp_13 = tmp17_input.x13(tmp0_desc, 8, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
          tmp12_local8 = tmp_13 == null ? null : tmp_13.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          var tmp_14 = $serializer_getInstance();
          var tmp_15 = tmp13_local9;
          var tmp_16 = tmp17_input.x13(tmp0_desc, 9, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
          tmp13_local9 = tmp_16 == null ? null : tmp_16.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          var tmp_17 = $serializer_getInstance();
          var tmp_18 = tmp14_local10;
          var tmp_19 = tmp17_input.x13(tmp0_desc, 10, tmp_17, tmp_18 == null ? null : new (MonetaryValue())(tmp_18));
          tmp14_local10 = tmp_19 == null ? null : tmp_19.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          var tmp_20 = $serializer_getInstance();
          var tmp_21 = tmp15_local11;
          var tmp_22 = tmp17_input.x13(tmp0_desc, 11, tmp_20, tmp_21 == null ? null : new (MonetaryValue())(tmp_21));
          tmp15_local11 = tmp_22 == null ? null : tmp_22.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          var tmp_23 = $serializer_getInstance();
          var tmp_24 = tmp16_local12;
          var tmp_25 = tmp17_input.x13(tmp0_desc, 12, tmp_23, tmp_24 == null ? null : new (MonetaryValue())(tmp_24));
          tmp16_local12 = tmp_25 == null ? null : tmp_25.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.x13(tmp0_desc, 2, tmp18_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.x13(tmp0_desc, 3, tmp18_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_26 = $serializer_getInstance();
                var tmp_27 = tmp8_local4;
                var tmp_28 = tmp17_input.x13(tmp0_desc, 4, tmp_26, tmp_27 == null ? null : new (MonetaryValue())(tmp_27));
                tmp8_local4 = tmp_28 == null ? null : tmp_28.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_29 = $serializer_getInstance();
                var tmp_30 = tmp9_local5;
                var tmp_31 = tmp17_input.x13(tmp0_desc, 5, tmp_29, tmp_30 == null ? null : new (MonetaryValue())(tmp_30));
                tmp9_local5 = tmp_31 == null ? null : tmp_31.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_32 = $serializer_getInstance();
                var tmp_33 = tmp10_local6;
                var tmp_34 = tmp17_input.x13(tmp0_desc, 6, tmp_32, tmp_33 == null ? null : new (MonetaryValue())(tmp_33));
                tmp10_local6 = tmp_34 == null ? null : tmp_34.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_35 = $serializer_getInstance();
                var tmp_36 = tmp11_local7;
                var tmp_37 = tmp17_input.x13(tmp0_desc, 7, tmp_35, tmp_36 == null ? null : new (MonetaryValue())(tmp_36));
                tmp11_local7 = tmp_37 == null ? null : tmp_37.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                var tmp_38 = $serializer_getInstance();
                var tmp_39 = tmp12_local8;
                var tmp_40 = tmp17_input.x13(tmp0_desc, 8, tmp_38, tmp_39 == null ? null : new (MonetaryValue())(tmp_39));
                tmp12_local8 = tmp_40 == null ? null : tmp_40.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                var tmp_41 = $serializer_getInstance();
                var tmp_42 = tmp13_local9;
                var tmp_43 = tmp17_input.x13(tmp0_desc, 9, tmp_41, tmp_42 == null ? null : new (MonetaryValue())(tmp_42));
                tmp13_local9 = tmp_43 == null ? null : tmp_43.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                var tmp_44 = $serializer_getInstance();
                var tmp_45 = tmp14_local10;
                var tmp_46 = tmp17_input.x13(tmp0_desc, 10, tmp_44, tmp_45 == null ? null : new (MonetaryValue())(tmp_45));
                tmp14_local10 = tmp_46 == null ? null : tmp_46.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                var tmp_47 = $serializer_getInstance();
                var tmp_48 = tmp15_local11;
                var tmp_49 = tmp17_input.x13(tmp0_desc, 11, tmp_47, tmp_48 == null ? null : new (MonetaryValue())(tmp_48));
                tmp15_local11 = tmp_49 == null ? null : tmp_49.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                var tmp_50 = $serializer_getInstance();
                var tmp_51 = tmp16_local12;
                var tmp_52 = tmp17_input.x13(tmp0_desc, 12, tmp_50, tmp_51 == null ? null : new (MonetaryValue())(tmp_51));
                tmp16_local12 = tmp_52 == null ? null : tmp_52.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return ProjectEscrowHomeownerSnapshotReport().e9q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.c9q_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_6().c8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), tmp0_cached[3].f2(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_5() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var ProjectEscrowHomeownerSnapshotReportClass;
function ProjectEscrowHomeownerSnapshotReport() {
  if (ProjectEscrowHomeownerSnapshotReportClass === VOID) {
    class $ {
      p9o() {
        return TableRow_0().o9p(this);
      }
      toString() {
        return 'ProjectEscrowHomeownerSnapshotReport(project=' + this.p9p_1.toString() + ', beneficiaryName=' + this.q9p_1 + ', state=' + this.r9p_1.toString() + ', projectState=' + toString(this.s9p_1) + ', totalDeposits=' + MonetaryValue__toString_impl_xslc77(this.t9p_1) + ', totalSignedOff=' + MonetaryValue__toString_impl_xslc77(this.u9p_1) + ', contractorSignedOffPortion=' + MonetaryValue__toString_impl_xslc77(this.v9p_1) + ', crowpayFeeEarned=' + MonetaryValue__toString_impl_xslc77(this.w9p_1) + ', contractorCollected=' + MonetaryValue__toString_impl_xslc77(this.x9p_1) + ', clientCollected=' + MonetaryValue__toString_impl_xslc77(this.y9p_1) + ', totalInEscrow=' + MonetaryValue__toString_impl_xslc77(this.z9p_1) + ', projectEscrow=' + MonetaryValue__toString_impl_xslc77(this.a9q_1) + ', contractorPayableEscrow=' + MonetaryValue__toString_impl_xslc77(this.b9q_1) + ')';
      }
      hashCode() {
        var result = this.p9p_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.q9p_1) | 0;
        result = imul(result, 31) + this.r9p_1.hashCode() | 0;
        result = imul(result, 31) + this.s9p_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.t9p_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.u9p_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.v9p_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.w9p_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.x9p_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.y9p_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.z9p_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.a9q_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.b9q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectEscrowHomeownerSnapshotReport()))
          return false;
        if (!this.p9p_1.equals(other.p9p_1))
          return false;
        if (!(this.q9p_1 === other.q9p_1))
          return false;
        if (!this.r9p_1.equals(other.r9p_1))
          return false;
        if (!this.s9p_1.equals(other.s9p_1))
          return false;
        if (!(this.t9p_1 === other.t9p_1))
          return false;
        if (!(this.u9p_1 === other.u9p_1))
          return false;
        if (!(this.v9p_1 === other.v9p_1))
          return false;
        if (!(this.w9p_1 === other.w9p_1))
          return false;
        if (!(this.x9p_1 === other.x9p_1))
          return false;
        if (!(this.y9p_1 === other.y9p_1))
          return false;
        if (!(this.z9p_1 === other.z9p_1))
          return false;
        if (!(this.a9q_1 === other.a9q_1))
          return false;
        if (!(this.b9q_1 === other.b9q_1))
          return false;
        return true;
      }
      static e9q(seen0, project, beneficiaryName, state, projectState, totalDeposits, totalSignedOff, contractorSignedOffPortion, crowpayFeeEarned, contractorCollected, clientCollected, totalInEscrow, projectEscrow, contractorPayableEscrow, serializationConstructorMarker) {
        Companion_getInstance_6();
        if (!(8191 === (8191 & seen0))) {
          throwMissingFieldException(seen0, 8191, $serializer_getInstance_5().c9q_1);
        }
        var $this = createThis(this);
        $this.p9p_1 = project;
        $this.q9p_1 = beneficiaryName;
        $this.r9p_1 = state;
        $this.s9p_1 = projectState;
        $this.t9p_1 = totalDeposits;
        $this.u9p_1 = totalSignedOff;
        $this.v9p_1 = contractorSignedOffPortion;
        $this.w9p_1 = crowpayFeeEarned;
        $this.x9p_1 = contractorCollected;
        $this.y9p_1 = clientCollected;
        $this.z9p_1 = totalInEscrow;
        $this.a9q_1 = projectEscrow;
        $this.b9q_1 = contractorPayableEscrow;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectEscrowHomeownerSnapshotReport', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
    ProjectEscrowHomeownerSnapshotReportClass = $;
  }
  return ProjectEscrowHomeownerSnapshotReportClass;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_7() {
  return Companion_instance_5;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowPeriodReport.TableRow', this, 15);
        tmp0_serialDesc.c1b('Project ID', false);
        tmp0_serialDesc.c1b('Contractor', false);
        tmp0_serialDesc.c1b('State', false);
        tmp0_serialDesc.c1b('Total Deposits', false);
        tmp0_serialDesc.c1b('Total Signed-Off', false);
        tmp0_serialDesc.c1b('Contractor Signed-Off Portion', false);
        tmp0_serialDesc.c1b('CrowPay Fee Earned', false);
        tmp0_serialDesc.c1b('Contractor Collected Amount', false);
        tmp0_serialDesc.c1b('Client Collected Amount', false);
        tmp0_serialDesc.c1b('Average Daily Total Escrow', false);
        tmp0_serialDesc.c1b('Average Daily Project Escrow', false);
        tmp0_serialDesc.c1b('Average Daily Contractor Payable Escrow', false);
        tmp0_serialDesc.c1b('Total Escrow Net Change', false);
        tmp0_serialDesc.c1b('Project Escrow Net Change', false);
        tmp0_serialDesc.c1b('Contractor Payable Net Change', false);
        this.f9q_1 = tmp0_serialDesc;
      }
      g9q(encoder, value) {
        var tmp0_desc = this.f9q_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.h9q_1);
        tmp1_output.a15(tmp0_desc, 1, value.i9q_1);
        tmp1_output.a15(tmp0_desc, 2, value.j9q_1);
        tmp1_output.a15(tmp0_desc, 3, value.k9q_1);
        tmp1_output.a15(tmp0_desc, 4, value.l9q_1);
        tmp1_output.a15(tmp0_desc, 5, value.m9q_1);
        tmp1_output.a15(tmp0_desc, 6, value.n9q_1);
        tmp1_output.a15(tmp0_desc, 7, value.o9q_1);
        tmp1_output.a15(tmp0_desc, 8, value.p9q_1);
        tmp1_output.a15(tmp0_desc, 9, value.q9q_1);
        tmp1_output.a15(tmp0_desc, 10, value.r9q_1);
        tmp1_output.a15(tmp0_desc, 11, value.s9q_1);
        tmp1_output.a15(tmp0_desc, 12, value.t9q_1);
        tmp1_output.a15(tmp0_desc, 13, value.u9q_1);
        tmp1_output.a15(tmp0_desc, 14, value.v9q_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g9q(encoder, value instanceof TableRow_1() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f9q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_input = decoder.l13(tmp0_desc);
        if (tmp19_input.a14()) {
          tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp19_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp19_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp19_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp19_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp19_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp19_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp19_input.v13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp19_input.v13(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp19_input.v13(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp19_input.v13(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp19_input.v13(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp19_input.v13(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp19_input.v13(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp19_input.v13(tmp0_desc, 14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp19_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp19_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp19_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp19_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp19_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp19_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp19_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp19_input.v13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp19_input.v13(tmp0_desc, 8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp19_input.v13(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp19_input.v13(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp19_input.v13(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp19_input.v13(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp19_input.v13(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp19_input.v13(tmp0_desc, 14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp19_input.m13(tmp0_desc);
        return TableRow_1().w9q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
      }
      az() {
        return this.f9q_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_6() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function ProjectEscrowPeriodReport$Request$Companion$$childSerializers$_anonymous__3rpegc() {
  return new (LinkedHashSetSerializer())(DeferToContextualUuidSerializer_getInstance());
}
function ProjectEscrowPeriodReport$Request$Companion$$childSerializers$_anonymous__3rpegc_0() {
  return new (LinkedHashSetSerializer())(DeferToContextualUuidSerializer_getInstance());
}
function ProjectEscrowPeriodReport$Request$Companion$$childSerializers$_anonymous__3rpegc_1() {
  return new (LinkedHashSetSerializer())(Companion_getInstance().m2a());
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ProjectEscrowPeriodReport$Request$Companion$$childSerializers$_anonymous__3rpegc);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ProjectEscrowPeriodReport$Request$Companion$$childSerializers$_anonymous__3rpegc_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.f8s_1 = [null, null, tmp_1, tmp_3, lazy(tmp_4, ProjectEscrowPeriodReport$Request$Companion$$childSerializers$_anonymous__3rpegc_1)];
      }
      m2a() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_8() {
  if (Companion_instance_6 === VOID)
    new (Companion_6())();
  return Companion_instance_6;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowPeriodReport.Request', this, 5);
        tmp0_serialDesc.c1b('start', false);
        tmp0_serialDesc.c1b('endInclusive', false);
        tmp0_serialDesc.c1b('contractorIds', false);
        tmp0_serialDesc.c1b('projectIds', false);
        tmp0_serialDesc.c1b('states', false);
        this.x9q_1 = tmp0_serialDesc;
      }
      y9q(encoder, value) {
        var tmp0_desc = this.x9q_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_8().f8s_1;
        tmp1_output.c15(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), value.z9q_1);
        tmp1_output.c15(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), value.a9r_1);
        tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.b9r_1);
        tmp1_output.d15(tmp0_desc, 3, tmp2_cached[3].f2(), value.c9r_1);
        tmp1_output.d15(tmp0_desc, 4, tmp2_cached[4].f2(), value.d9r_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y9q(encoder, value instanceof Request_1() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x9q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp10_input = decoder.l13(tmp0_desc);
        var tmp11_cached = Companion_getInstance_8().f8s_1;
        if (tmp10_input.a14()) {
          tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.z13(tmp0_desc, 2, tmp11_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.z13(tmp0_desc, 3, tmp11_cached[3].f2(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.z13(tmp0_desc, 4, tmp11_cached[4].f2(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.x13(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.x13(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.z13(tmp0_desc, 2, tmp11_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.z13(tmp0_desc, 3, tmp11_cached[3].f2(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.z13(tmp0_desc, 4, tmp11_cached[4].f2(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp10_input.m13(tmp0_desc);
        return Request_1().f9r(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      az() {
        return this.x9q_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_8().f8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [InstantIso8601Serializer_getInstance(), InstantIso8601Serializer_getInstance(), get_nullable(tmp0_cached[2].f2()), get_nullable(tmp0_cached[3].f2()), get_nullable(tmp0_cached[4].f2())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_7() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function ProjectEscrowPeriodReport$Companion$$childSerializers$_anonymous__amb513() {
  return Companion_getInstance().m2a();
}
var TableRowClass_1;
function TableRow_1() {
  if (TableRowClass_1 === VOID) {
    class $ {
      static g9r(Project_ID_dy942, Contractor, State, Total_Deposits_ieuyb5, Total_Signed_Off_ez7a6e, Contractor_Signed_Off_Portion_x4abf4, CrowPay_Fee_Earned_y8z2ao, Contractor_Collected_Amount_f8xapy, Client_Collected_Amount_rxbcws, Average_Daily_Total_Escrow_opv61h, Average_Daily_Project_Escrow_g95v0q, Average_Daily_Contractor_Payable_Escrow_cvv9do, Total_Escrow_Net_Change_ufgia6, Project_Escrow_Net_Change_ebs1rt, Contractor_Payable_Net_Change_ybuv5o) {
        var $this = createThis(this);
        $this.h9q_1 = Project_ID_dy942;
        $this.i9q_1 = Contractor;
        $this.j9q_1 = State;
        $this.k9q_1 = Total_Deposits_ieuyb5;
        $this.l9q_1 = Total_Signed_Off_ez7a6e;
        $this.m9q_1 = Contractor_Signed_Off_Portion_x4abf4;
        $this.n9q_1 = CrowPay_Fee_Earned_y8z2ao;
        $this.o9q_1 = Contractor_Collected_Amount_f8xapy;
        $this.p9q_1 = Client_Collected_Amount_rxbcws;
        $this.q9q_1 = Average_Daily_Total_Escrow_opv61h;
        $this.r9q_1 = Average_Daily_Project_Escrow_g95v0q;
        $this.s9q_1 = Average_Daily_Contractor_Payable_Escrow_cvv9do;
        $this.t9q_1 = Total_Escrow_Net_Change_ufgia6;
        $this.u9q_1 = Project_Escrow_Net_Change_ebs1rt;
        $this.v9q_1 = Contractor_Payable_Net_Change_ybuv5o;
        return $this;
      }
      static h9r(snapshot) {
        return this.g9r(snapshot.i9r_1, snapshot.j9r_1, snapshot.k9r_1.e9b_1, MonetaryValue__toFullString_impl_igjjwy(snapshot.l9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.m9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.n9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.o9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.p9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.q9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.r9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.s9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.t9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.u9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.v9r_1), MonetaryValue__toFullString_impl_igjjwy(snapshot.w9r_1));
      }
      toString() {
        return 'TableRow(Project ID=' + this.h9q_1.toString() + ', Contractor=' + this.i9q_1 + ', State=' + this.j9q_1 + ', Total Deposits=' + this.k9q_1 + ', Total Signed-Off=' + this.l9q_1 + ', Contractor Signed-Off Portion=' + this.m9q_1 + ', CrowPay Fee Earned=' + this.n9q_1 + ', Contractor Collected Amount=' + this.o9q_1 + ', Client Collected Amount=' + this.p9q_1 + ', Average Daily Total Escrow=' + this.q9q_1 + ', Average Daily Project Escrow=' + this.r9q_1 + ', Average Daily Contractor Payable Escrow=' + this.s9q_1 + ', Total Escrow Net Change=' + this.t9q_1 + ', Project Escrow Net Change=' + this.u9q_1 + ', Contractor Payable Net Change=' + this.v9q_1 + ')';
      }
      hashCode() {
        var result = this.h9q_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.i9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u9q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v9q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TableRow_1()))
          return false;
        if (!this.h9q_1.equals(other.h9q_1))
          return false;
        if (!(this.i9q_1 === other.i9q_1))
          return false;
        if (!(this.j9q_1 === other.j9q_1))
          return false;
        if (!(this.k9q_1 === other.k9q_1))
          return false;
        if (!(this.l9q_1 === other.l9q_1))
          return false;
        if (!(this.m9q_1 === other.m9q_1))
          return false;
        if (!(this.n9q_1 === other.n9q_1))
          return false;
        if (!(this.o9q_1 === other.o9q_1))
          return false;
        if (!(this.p9q_1 === other.p9q_1))
          return false;
        if (!(this.q9q_1 === other.q9q_1))
          return false;
        if (!(this.r9q_1 === other.r9q_1))
          return false;
        if (!(this.s9q_1 === other.s9q_1))
          return false;
        if (!(this.t9q_1 === other.t9q_1))
          return false;
        if (!(this.u9q_1 === other.u9q_1))
          return false;
        if (!(this.v9q_1 === other.v9q_1))
          return false;
        return true;
      }
      static w9q(seen0, Project_ID_dy942, Contractor, State, Total_Deposits_ieuyb5, Total_Signed_Off_ez7a6e, Contractor_Signed_Off_Portion_x4abf4, CrowPay_Fee_Earned_y8z2ao, Contractor_Collected_Amount_f8xapy, Client_Collected_Amount_rxbcws, Average_Daily_Total_Escrow_opv61h, Average_Daily_Project_Escrow_g95v0q, Average_Daily_Contractor_Payable_Escrow_cvv9do, Total_Escrow_Net_Change_ufgia6, Project_Escrow_Net_Change_ebs1rt, Contractor_Payable_Net_Change_ybuv5o, serializationConstructorMarker) {
        if (!(32767 === (32767 & seen0))) {
          throwMissingFieldException(seen0, 32767, $serializer_getInstance_6().f9q_1);
        }
        var $this = createThis(this);
        $this.h9q_1 = Project_ID_dy942;
        $this.i9q_1 = Contractor;
        $this.j9q_1 = State;
        $this.k9q_1 = Total_Deposits_ieuyb5;
        $this.l9q_1 = Total_Signed_Off_ez7a6e;
        $this.m9q_1 = Contractor_Signed_Off_Portion_x4abf4;
        $this.n9q_1 = CrowPay_Fee_Earned_y8z2ao;
        $this.o9q_1 = Contractor_Collected_Amount_f8xapy;
        $this.p9q_1 = Client_Collected_Amount_rxbcws;
        $this.q9q_1 = Average_Daily_Total_Escrow_opv61h;
        $this.r9q_1 = Average_Daily_Project_Escrow_g95v0q;
        $this.s9q_1 = Average_Daily_Contractor_Payable_Escrow_cvv9do;
        $this.t9q_1 = Total_Escrow_Net_Change_ufgia6;
        $this.u9q_1 = Project_Escrow_Net_Change_ebs1rt;
        $this.v9q_1 = Contractor_Payable_Net_Change_ybuv5o;
        return $this;
      }
    }
    initMetadataForClass($, 'TableRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
    TableRowClass_1 = $;
  }
  return TableRowClass_1;
}
var RequestClass_1;
function Request_1() {
  if (RequestClass_1 === VOID) {
    class $ {
      constructor(start, endInclusive, contractorIds, projectIds, states) {
        Companion_getInstance_8();
        this.z9q_1 = start;
        this.a9r_1 = endInclusive;
        this.b9r_1 = contractorIds;
        this.c9r_1 = projectIds;
        this.d9r_1 = states;
        this.e9r_1 = rangeTo(this.z9q_1, this.a9r_1);
      }
      toString() {
        return 'Request(start=' + this.z9q_1.toString() + ', endInclusive=' + this.a9r_1.toString() + ', contractorIds=' + toString_0(this.b9r_1) + ', projectIds=' + toString_0(this.c9r_1) + ', states=' + toString_0(this.d9r_1) + ')';
      }
      hashCode() {
        var result = this.z9q_1.hashCode();
        result = imul(result, 31) + this.a9r_1.hashCode() | 0;
        result = imul(result, 31) + (this.b9r_1 == null ? 0 : hashCode(this.b9r_1)) | 0;
        result = imul(result, 31) + (this.c9r_1 == null ? 0 : hashCode(this.c9r_1)) | 0;
        result = imul(result, 31) + (this.d9r_1 == null ? 0 : hashCode(this.d9r_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Request_1()))
          return false;
        if (!this.z9q_1.equals(other.z9q_1))
          return false;
        if (!this.a9r_1.equals(other.a9r_1))
          return false;
        if (!equals(this.b9r_1, other.b9r_1))
          return false;
        if (!equals(this.c9r_1, other.c9r_1))
          return false;
        if (!equals(this.d9r_1, other.d9r_1))
          return false;
        return true;
      }
      static f9r(seen0, start, endInclusive, contractorIds, projectIds, states, serializationConstructorMarker) {
        Companion_getInstance_8();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance_7().x9q_1);
        }
        var $this = createThis(this);
        $this.z9q_1 = start;
        $this.a9r_1 = endInclusive;
        $this.b9r_1 = contractorIds;
        $this.c9r_1 = projectIds;
        $this.d9r_1 = states;
        $this.e9r_1 = rangeTo($this.z9q_1, $this.a9r_1);
        return $this;
      }
    }
    initMetadataForClass($, 'Request', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
    RequestClass_1 = $;
  }
  return RequestClass_1;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e8s_1 = [null, null, lazy(tmp_0, ProjectEscrowPeriodReport$Companion$$childSerializers$_anonymous__amb513), null, null, null, null, null, null, null, null, null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_9() {
  if (Companion_instance_7 === VOID)
    new (Companion_7())();
  return Companion_instance_7;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.reports.ProjectEscrowPeriodReport', this, 15);
        tmp0_serialDesc.c1b('project', false);
        tmp0_serialDesc.c1b('contractorName', false);
        tmp0_serialDesc.c1b('state', false);
        tmp0_serialDesc.c1b('totalDeposits', false);
        tmp0_serialDesc.c1b('totalSignedOff', false);
        tmp0_serialDesc.c1b('contractorSignedOffPortion', false);
        tmp0_serialDesc.c1b('crowpayFeeEarned', false);
        tmp0_serialDesc.c1b('contractorCollected', false);
        tmp0_serialDesc.c1b('clientCollected', false);
        tmp0_serialDesc.c1b('averageDailyTotalEscrow', false);
        tmp0_serialDesc.c1b('averageDailyProjectEscrow', false);
        tmp0_serialDesc.c1b('averageDailyContractorPayableEscrow', false);
        tmp0_serialDesc.c1b('totalEscrowNetChange', false);
        tmp0_serialDesc.c1b('projectEscrowNetChange', false);
        tmp0_serialDesc.c1b('contractorPayableNetChange', false);
        this.x9r_1 = tmp0_serialDesc;
      }
      y9r(encoder, value) {
        var tmp0_desc = this.x9r_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_9().e8s_1;
        tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.i9r_1);
        tmp1_output.a15(tmp0_desc, 1, value.j9r_1);
        tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.k9r_1);
        tmp1_output.c15(tmp0_desc, 3, $serializer_getInstance(), new (MonetaryValue())(value.l9r_1));
        tmp1_output.c15(tmp0_desc, 4, $serializer_getInstance(), new (MonetaryValue())(value.m9r_1));
        tmp1_output.c15(tmp0_desc, 5, $serializer_getInstance(), new (MonetaryValue())(value.n9r_1));
        tmp1_output.c15(tmp0_desc, 6, $serializer_getInstance(), new (MonetaryValue())(value.o9r_1));
        tmp1_output.c15(tmp0_desc, 7, $serializer_getInstance(), new (MonetaryValue())(value.p9r_1));
        tmp1_output.c15(tmp0_desc, 8, $serializer_getInstance(), new (MonetaryValue())(value.q9r_1));
        tmp1_output.c15(tmp0_desc, 9, $serializer_getInstance(), new (MonetaryValue())(value.r9r_1));
        tmp1_output.c15(tmp0_desc, 10, $serializer_getInstance(), new (MonetaryValue())(value.s9r_1));
        tmp1_output.c15(tmp0_desc, 11, $serializer_getInstance(), new (MonetaryValue())(value.t9r_1));
        tmp1_output.c15(tmp0_desc, 12, $serializer_getInstance(), new (MonetaryValue())(value.u9r_1));
        tmp1_output.c15(tmp0_desc, 13, $serializer_getInstance(), new (MonetaryValue())(value.v9r_1));
        tmp1_output.c15(tmp0_desc, 14, $serializer_getInstance(), new (MonetaryValue())(value.w9r_1));
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y9r(encoder, value instanceof ProjectEscrowPeriodReport() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x9r_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_input = decoder.l13(tmp0_desc);
        var tmp20_cached = Companion_getInstance_9().e8s_1;
        if (tmp19_input.a14()) {
          tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp19_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp19_input.x13(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = $serializer_getInstance();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp19_input.x13(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (MonetaryValue())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_2 = $serializer_getInstance();
          var tmp_3 = tmp8_local4;
          var tmp_4 = tmp19_input.x13(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new (MonetaryValue())(tmp_3));
          tmp8_local4 = tmp_4 == null ? null : tmp_4.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          var tmp_5 = $serializer_getInstance();
          var tmp_6 = tmp9_local5;
          var tmp_7 = tmp19_input.x13(tmp0_desc, 5, tmp_5, tmp_6 == null ? null : new (MonetaryValue())(tmp_6));
          tmp9_local5 = tmp_7 == null ? null : tmp_7.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp_8 = $serializer_getInstance();
          var tmp_9 = tmp10_local6;
          var tmp_10 = tmp19_input.x13(tmp0_desc, 6, tmp_8, tmp_9 == null ? null : new (MonetaryValue())(tmp_9));
          tmp10_local6 = tmp_10 == null ? null : tmp_10.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          var tmp_11 = $serializer_getInstance();
          var tmp_12 = tmp11_local7;
          var tmp_13 = tmp19_input.x13(tmp0_desc, 7, tmp_11, tmp_12 == null ? null : new (MonetaryValue())(tmp_12));
          tmp11_local7 = tmp_13 == null ? null : tmp_13.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          var tmp_14 = $serializer_getInstance();
          var tmp_15 = tmp12_local8;
          var tmp_16 = tmp19_input.x13(tmp0_desc, 8, tmp_14, tmp_15 == null ? null : new (MonetaryValue())(tmp_15));
          tmp12_local8 = tmp_16 == null ? null : tmp_16.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          var tmp_17 = $serializer_getInstance();
          var tmp_18 = tmp13_local9;
          var tmp_19 = tmp19_input.x13(tmp0_desc, 9, tmp_17, tmp_18 == null ? null : new (MonetaryValue())(tmp_18));
          tmp13_local9 = tmp_19 == null ? null : tmp_19.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          var tmp_20 = $serializer_getInstance();
          var tmp_21 = tmp14_local10;
          var tmp_22 = tmp19_input.x13(tmp0_desc, 10, tmp_20, tmp_21 == null ? null : new (MonetaryValue())(tmp_21));
          tmp14_local10 = tmp_22 == null ? null : tmp_22.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          var tmp_23 = $serializer_getInstance();
          var tmp_24 = tmp15_local11;
          var tmp_25 = tmp19_input.x13(tmp0_desc, 11, tmp_23, tmp_24 == null ? null : new (MonetaryValue())(tmp_24));
          tmp15_local11 = tmp_25 == null ? null : tmp_25.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          var tmp_26 = $serializer_getInstance();
          var tmp_27 = tmp16_local12;
          var tmp_28 = tmp19_input.x13(tmp0_desc, 12, tmp_26, tmp_27 == null ? null : new (MonetaryValue())(tmp_27));
          tmp16_local12 = tmp_28 == null ? null : tmp_28.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          var tmp_29 = $serializer_getInstance();
          var tmp_30 = tmp17_local13;
          var tmp_31 = tmp19_input.x13(tmp0_desc, 13, tmp_29, tmp_30 == null ? null : new (MonetaryValue())(tmp_30));
          tmp17_local13 = tmp_31 == null ? null : tmp_31.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          var tmp_32 = $serializer_getInstance();
          var tmp_33 = tmp18_local14;
          var tmp_34 = tmp19_input.x13(tmp0_desc, 14, tmp_32, tmp_33 == null ? null : new (MonetaryValue())(tmp_33));
          tmp18_local14 = tmp_34 == null ? null : tmp_34.a5s_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp19_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp19_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp19_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp19_input.x13(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_35 = $serializer_getInstance();
                var tmp_36 = tmp7_local3;
                var tmp_37 = tmp19_input.x13(tmp0_desc, 3, tmp_35, tmp_36 == null ? null : new (MonetaryValue())(tmp_36));
                tmp7_local3 = tmp_37 == null ? null : tmp_37.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_38 = $serializer_getInstance();
                var tmp_39 = tmp8_local4;
                var tmp_40 = tmp19_input.x13(tmp0_desc, 4, tmp_38, tmp_39 == null ? null : new (MonetaryValue())(tmp_39));
                tmp8_local4 = tmp_40 == null ? null : tmp_40.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                var tmp_41 = $serializer_getInstance();
                var tmp_42 = tmp9_local5;
                var tmp_43 = tmp19_input.x13(tmp0_desc, 5, tmp_41, tmp_42 == null ? null : new (MonetaryValue())(tmp_42));
                tmp9_local5 = tmp_43 == null ? null : tmp_43.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_44 = $serializer_getInstance();
                var tmp_45 = tmp10_local6;
                var tmp_46 = tmp19_input.x13(tmp0_desc, 6, tmp_44, tmp_45 == null ? null : new (MonetaryValue())(tmp_45));
                tmp10_local6 = tmp_46 == null ? null : tmp_46.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                var tmp_47 = $serializer_getInstance();
                var tmp_48 = tmp11_local7;
                var tmp_49 = tmp19_input.x13(tmp0_desc, 7, tmp_47, tmp_48 == null ? null : new (MonetaryValue())(tmp_48));
                tmp11_local7 = tmp_49 == null ? null : tmp_49.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                var tmp_50 = $serializer_getInstance();
                var tmp_51 = tmp12_local8;
                var tmp_52 = tmp19_input.x13(tmp0_desc, 8, tmp_50, tmp_51 == null ? null : new (MonetaryValue())(tmp_51));
                tmp12_local8 = tmp_52 == null ? null : tmp_52.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                var tmp_53 = $serializer_getInstance();
                var tmp_54 = tmp13_local9;
                var tmp_55 = tmp19_input.x13(tmp0_desc, 9, tmp_53, tmp_54 == null ? null : new (MonetaryValue())(tmp_54));
                tmp13_local9 = tmp_55 == null ? null : tmp_55.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                var tmp_56 = $serializer_getInstance();
                var tmp_57 = tmp14_local10;
                var tmp_58 = tmp19_input.x13(tmp0_desc, 10, tmp_56, tmp_57 == null ? null : new (MonetaryValue())(tmp_57));
                tmp14_local10 = tmp_58 == null ? null : tmp_58.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                var tmp_59 = $serializer_getInstance();
                var tmp_60 = tmp15_local11;
                var tmp_61 = tmp19_input.x13(tmp0_desc, 11, tmp_59, tmp_60 == null ? null : new (MonetaryValue())(tmp_60));
                tmp15_local11 = tmp_61 == null ? null : tmp_61.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                var tmp_62 = $serializer_getInstance();
                var tmp_63 = tmp16_local12;
                var tmp_64 = tmp19_input.x13(tmp0_desc, 12, tmp_62, tmp_63 == null ? null : new (MonetaryValue())(tmp_63));
                tmp16_local12 = tmp_64 == null ? null : tmp_64.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                var tmp_65 = $serializer_getInstance();
                var tmp_66 = tmp17_local13;
                var tmp_67 = tmp19_input.x13(tmp0_desc, 13, tmp_65, tmp_66 == null ? null : new (MonetaryValue())(tmp_66));
                tmp17_local13 = tmp_67 == null ? null : tmp_67.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                var tmp_68 = $serializer_getInstance();
                var tmp_69 = tmp18_local14;
                var tmp_70 = tmp19_input.x13(tmp0_desc, 14, tmp_68, tmp_69 == null ? null : new (MonetaryValue())(tmp_69));
                tmp18_local14 = tmp_70 == null ? null : tmp_70.a5s_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp19_input.m13(tmp0_desc);
        return ProjectEscrowPeriodReport().z9r(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
      }
      az() {
        return this.x9r_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_9().e8s_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_8() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var ProjectEscrowPeriodReportClass;
function ProjectEscrowPeriodReport() {
  if (ProjectEscrowPeriodReportClass === VOID) {
    class $ {
      p9o() {
        return TableRow_1().h9r(this);
      }
      toString() {
        return 'ProjectEscrowPeriodReport(project=' + this.i9r_1.toString() + ', contractorName=' + this.j9r_1 + ', state=' + this.k9r_1.toString() + ', totalDeposits=' + MonetaryValue__toString_impl_xslc77(this.l9r_1) + ', totalSignedOff=' + MonetaryValue__toString_impl_xslc77(this.m9r_1) + ', contractorSignedOffPortion=' + MonetaryValue__toString_impl_xslc77(this.n9r_1) + ', crowpayFeeEarned=' + MonetaryValue__toString_impl_xslc77(this.o9r_1) + ', contractorCollected=' + MonetaryValue__toString_impl_xslc77(this.p9r_1) + ', clientCollected=' + MonetaryValue__toString_impl_xslc77(this.q9r_1) + ', averageDailyTotalEscrow=' + MonetaryValue__toString_impl_xslc77(this.r9r_1) + ', averageDailyProjectEscrow=' + MonetaryValue__toString_impl_xslc77(this.s9r_1) + ', averageDailyContractorPayableEscrow=' + MonetaryValue__toString_impl_xslc77(this.t9r_1) + ', totalEscrowNetChange=' + MonetaryValue__toString_impl_xslc77(this.u9r_1) + ', projectEscrowNetChange=' + MonetaryValue__toString_impl_xslc77(this.v9r_1) + ', contractorPayableNetChange=' + MonetaryValue__toString_impl_xslc77(this.w9r_1) + ')';
      }
      hashCode() {
        var result = this.i9r_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.j9r_1) | 0;
        result = imul(result, 31) + this.k9r_1.hashCode() | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.l9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.m9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.n9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.o9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.p9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.q9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.r9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.s9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.t9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.u9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.v9r_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.w9r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProjectEscrowPeriodReport()))
          return false;
        if (!this.i9r_1.equals(other.i9r_1))
          return false;
        if (!(this.j9r_1 === other.j9r_1))
          return false;
        if (!this.k9r_1.equals(other.k9r_1))
          return false;
        if (!(this.l9r_1 === other.l9r_1))
          return false;
        if (!(this.m9r_1 === other.m9r_1))
          return false;
        if (!(this.n9r_1 === other.n9r_1))
          return false;
        if (!(this.o9r_1 === other.o9r_1))
          return false;
        if (!(this.p9r_1 === other.p9r_1))
          return false;
        if (!(this.q9r_1 === other.q9r_1))
          return false;
        if (!(this.r9r_1 === other.r9r_1))
          return false;
        if (!(this.s9r_1 === other.s9r_1))
          return false;
        if (!(this.t9r_1 === other.t9r_1))
          return false;
        if (!(this.u9r_1 === other.u9r_1))
          return false;
        if (!(this.v9r_1 === other.v9r_1))
          return false;
        if (!(this.w9r_1 === other.w9r_1))
          return false;
        return true;
      }
      static z9r(seen0, project, contractorName, state, totalDeposits, totalSignedOff, contractorSignedOffPortion, crowpayFeeEarned, contractorCollected, clientCollected, averageDailyTotalEscrow, averageDailyProjectEscrow, averageDailyContractorPayableEscrow, totalEscrowNetChange, projectEscrowNetChange, contractorPayableNetChange, serializationConstructorMarker) {
        Companion_getInstance_9();
        if (!(32767 === (32767 & seen0))) {
          throwMissingFieldException(seen0, 32767, $serializer_getInstance_8().x9r_1);
        }
        var $this = createThis(this);
        $this.i9r_1 = project;
        $this.j9r_1 = contractorName;
        $this.k9r_1 = state;
        $this.l9r_1 = totalDeposits;
        $this.m9r_1 = totalSignedOff;
        $this.n9r_1 = contractorSignedOffPortion;
        $this.o9r_1 = crowpayFeeEarned;
        $this.p9r_1 = contractorCollected;
        $this.q9r_1 = clientCollected;
        $this.r9r_1 = averageDailyTotalEscrow;
        $this.s9r_1 = averageDailyProjectEscrow;
        $this.t9r_1 = averageDailyContractorPayableEscrow;
        $this.u9r_1 = totalEscrowNetChange;
        $this.v9r_1 = projectEscrowNetChange;
        $this.w9r_1 = contractorPayableNetChange;
        return $this;
      }
    }
    initMetadataForClass($, 'ProjectEscrowPeriodReport', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
    ProjectEscrowPeriodReportClass = $;
  }
  return ProjectEscrowPeriodReportClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_5 = new (Companion_5())();
//endregion
//region block: exports
export {
  Request_0 as Request3glwmc9ki362z,
  TableRow_0 as TableRowmc0fkjojxlg7,
  Request_1 as Request2vfyg2ximc6e0,
  TableRow_1 as TableRow1nek1w7062qwr,
  Request as Request19nuof0q5z3pj,
  TableRow as TableRow2fczmizw0a7dc,
  Companion_getInstance_6 as Companion_getInstance2siu14nwnk7au,
  Companion_getInstance_5 as Companion_getInstance1ezkh7nuucouo,
  Companion_instance_2 as Companion_instancegh74vger0zhj,
  Companion_getInstance_9 as Companion_getInstance2irbwqyuggdu2,
  Companion_getInstance_8 as Companion_getInstance1os6jge06wszv,
  Companion_instance_5 as Companion_instance1py5plpe5wxpw,
  Companion_getInstance_3 as Companion_getInstance3qf32mccbb2zd,
  Companion_getInstance_2 as Companion_getInstance2aea3v0bp26v5,
  Companion_instance as Companion_instancev69jsgezlim0,
};
//endregion

//# sourceMappingURL=reports.mjs.map
